import { SxProps, Theme } from '@mui/material';

type PriceSXType = {
	container: SxProps<Theme>;
};

export const priceSX = (theme: Theme, isStickyComponent?: boolean): PriceSXType => ({
	container: {
		[theme.breakpoints.down('md')]: {
			width: isStickyComponent ? 'max-content' : 'auto',
			float: isStickyComponent ? 'right' : 'none',
			...(isStickyComponent
				? {
						' span': {
							fontSize: '15px',
							lineHeight: '1.2',
						},
						' sup': {
							fontSize: '15px',
						},
				  }
				: {}),
		},
	},
});
